import { useEffect, useState, useCallback } from 'react';
import parse from 'html-react-parser';
import { Box, Button, Grid, Typography, useTheme } from '@material-ui/core';
import { PublicPageHeader } from 'views/components/headers';
import { CircularLoading, makeUtilClasses } from 'views';
import { useStyles } from './politica-page-styles';
import { useToastSaurus } from 'services/app';
import { CancelarIcon } from '../../../components/icons/cancelar-icon';
import { TermosIcon } from '../../../components/icons/termos-icon';
import { useConfirm } from 'material-ui-confirm';
import { useHistory } from 'react-router';
import { useSessaoAtual } from '../../../../services/app/providers/sessao-atual-provider/sessao-atual-provider';
import { isEmpty } from 'lodash';
import { AvancarIcon } from '../../../components/icons/avancar-icon';
import { useGetPolitica } from 'data/api/gestao/politica/get-politica';
import { usePostPoliticaAceitar } from 'data/api/gestao/politica/post-politica-aceitar';
import { PoliticaModel } from 'model/api/gestao/politica/politica-model';
import { PularIcon } from 'views/components/icons';

const PoliticaPage = () => {
  const utilClasses = makeUtilClasses();
  const classes = useStyles();
  const { postPoliticaAceitar, carregando: carregandoAceite } =
    usePostPoliticaAceitar();
  const { push: historyPush } = useHistory();
  const confirm = useConfirm();
  const {
    deslogar,
    carregando: carregandoLogin,
    usuario,
    persistirTermos,
  } = useSessaoAtual();
  const { showToast } = useToastSaurus();
  const theme = useTheme();
  const { getPolitica, carregando: carregandoGet } = useGetPolitica();

  const [politica, setPolitica] = useState<PoliticaModel>();
  const loading = carregandoAceite || carregandoGet || carregandoLogin;

  const rejeitarTermos = useCallback(() => {
    confirm({
      title: 'Rejeitar Termos de Uso?',
      description:
        'Infelizmente ao rejeitar os termos de uso, você não poderá acessar o sistema. Deseja realmente Rejeitar?',
      cancellationText: 'Recusar e Realizar Logoff',
      cancellationButtonProps: { color: 'secondary' },
      confirmationButtonProps: { variant: 'contained' },
      confirmationText: 'Ler Novamente',
    }).catch(() => {
      deslogar();
    });
  }, [deslogar, confirm]);

  const getTermos = useCallback(async () => {
    try {
      const ret = await getPolitica();
      if (ret.erro) throw ret.erro;

      if (isEmpty(ret.resultado?.data)) {
        persistirTermos(true, 200);
        historyPush('/dashboard');
        return;
      }

      persistirTermos(false, 400);

      setPolitica(ret.resultado?.data[0]);
    } catch (e: any) {
      showToast('error', e.message);
      deslogar();
      historyPush('/login');
    }
  }, [deslogar, getPolitica, historyPush, persistirTermos, showToast]);

  const finalizarProcesso = useCallback(
    async (adiarAceite: boolean = false) => {
      try {
        debugger
        if (adiarAceite) {
          persistirTermos(true, 200, adiarAceite);
          historyPush('dashboard/');
          return;
        }
        const ret = await postPoliticaAceitar(politica!.id);

        if (ret.erro) throw ret.erro;

        persistirTermos(true, ret.statusCode);
        historyPush('dashboard/');
      } catch (e: Error | any) {
        showToast('error', e.message);
      }
    },
    [postPoliticaAceitar, politica, persistirTermos, historyPush, showToast],
  );

  const aceitarTermosSimples = useCallback(
    (adiarAceite: boolean = false) => {
      finalizarProcesso(adiarAceite);
    },
    [finalizarProcesso],
  );

  useEffect(() => {
    if (usuario) {
      getTermos();
    } else {
      historyPush('/login');
    }
  }, [getTermos, historyPush, usuario]);

  return (
    <>
      <PublicPageHeader topOpacity="0.8" />
      <div className={utilClasses.contentCenter}>
        <Grid
          container
          className={utilClasses.rootContainer}
          style={{
            maxWidth: 850,
          }}
        >
          {loading || isEmpty(politica) ? (
            <CircularLoading tipo="FULLSIZED" />
          ) : null}
          {!loading && !isEmpty(politica) && (
            <Grid item xs={12}>
              <Typography align="center" variant="h3" color="primary">
                <TermosIcon tipo="GERAL" class={classes.imgTitulo} />
                Termos de Uso
              </Typography>
              <Box mt={3}>
                <Typography align="center" variant="body1">
                  Leia os termos de uso e política de privacidade para continuar
                  o acesso ao sistema.
                </Typography>
              </Box>
              <>
                <div className={classes.termosDeUso}>
                  {parse(politica?.termo || '')}
                </div>
                <Box mt={5}>
                  <Grid spacing={2} container>
                    <Grid item xs={12} sm={6}>
                      <Button
                        type="submit"
                        color="primary"
                        variant="outlined"
                        fullWidth={true}
                        disabled={loading}
                        onClick={() => {
                          rejeitarTermos();
                        }}
                      >
                        <CancelarIcon
                          fill={theme.palette.primary.main}
                          tipo="BUTTON"
                        />
                        Recusar e Sair
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        fullWidth={true}
                        disabled={loading}
                        onClick={() => {
                          aceitarTermosSimples();
                        }}
                      >
                        <AvancarIcon tipo="BUTTON_PRIMARY" />
                        Aceitar e Continuar
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        color="primary"
                        variant="text"
                        fullWidth={true}
                        disabled={loading}
                        onClick={() => {
                          aceitarTermosSimples(true);
                        }}
                      >
                        <PularIcon tipo="BUTTON" />
                        Adiar Aceite
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
};

export default PoliticaPage;
